/* src/Pages/PreOrder/PreOrderUpload/components/ImageUploadSection.js - Updated */
import React from "react";
import CameraComponent from "../../Camera";

const ImageUploadSection = ({
  imagePreview,
  faceValidation,
  showCamera,
  isValidating,
  fileInputRef,
  onGallerySelect,
  onFileChange,
  onOpenCamera,
  onCloseCamera,
  onCapturedImage,
  onRemoveImage,
  imageRequired = true, // Default to true for backward compatibility
}) => {
  return (
    <>
      {/* New styling that matches other sections */}
      <div className="form-group">
        <label htmlFor="imageUpload">
          תמונת פנים
          {imageRequired && <span style={{ color: "#e74c3c" }}> *</span>}
        </label>

        <div className="upload-actions">
          <button
            type="button"
            className="upload-button gallery-button"
            onClick={onGallerySelect}
            disabled={isValidating}
          >
            <span className="button-text">בחירה מגלריה</span>
            <span className="high-quality-badge">מומלץ לאיכות גבוהה</span>
          </button>

          <button
            type="button"
            className="upload-button camera-button"
            onClick={onOpenCamera}
            disabled={isValidating}
          >
            צילום תמונה
          </button>
        </div>

        <input
          type="file"
          id="imageUpload"
          ref={fileInputRef}
          onChange={onFileChange}
          accept="image/*"
          style={{ display: "none" }}
        />
      </div>

      {/* Show camera modal when active */}
      {showCamera && (
        <CameraComponent onCapture={onCapturedImage} onClose={onCloseCamera} />
      )}

      {/* Image preview with validation status */}
      {imagePreview && (
        <div
          className={`image-preview-container ${
            isValidating ? "validating" : ""
          }`}
        >
          <img
            src={imagePreview}
            alt="תצוגה מקדימה"
            className="image-preview"
          />
          {faceValidation && (
            <div
              className={`image-validation-status ${
                faceValidation.valid ? "valid" : "invalid"
              }`}
            >
              {faceValidation.message || (isValidating ? "בודק תמונה..." : "")}
            </div>
          )}
          <button
            type="button"
            className="remove-image-button"
            onClick={onRemoveImage}
            aria-label="הסר תמונה"
          >
            ✕
          </button>
        </div>
      )}

      <div className="image-requirements">
        <h4>דרישות התמונה:</h4>
        <ul>
          <li>פנים במרכז התמונה</li>
          <li>מבט ישיר למצלמה</li>
          <li>תאורה טובה (איכות אופטימלית)</li>
          <li>כל הפנים והשיער נראים בבירור</li>
          <li>יש לשים לב שהתמונה אינה חתוכה!</li>
        </ul>
        <div className="image-requirements-summary">
          בקיצור, סלפי במרחק יד זה אידיאלי!
        </div>
      </div>
    </>
  );
};

export default ImageUploadSection;
